<cc-multi-select-autocomplete
  [formControl]="formControl"
  [searchDataFunction]="dataFunction"
  valueBinding="id"
  lableBinding="name"
  placeholder="bo.common.COMPANIES"
></cc-multi-select-autocomplete>
